(() => {
  /* The following allows for cursor navigation in between all currently visible menu items */
  window.swinger.navigationHelper.enableArrowNav('.swinger-navigation');
})();
